export const updateHero = () => {
    const hero = document.querySelector('#hero');
    if (!hero) {
        // Having the main section invisible until the final layout if computed prevents a massive content shift
        document.getElementById('main').style.visibility = 'visible';
        return;
    }

    const header = document.getElementById('header');
    const heroContent = hero.querySelector('#hero-content');
    const heroBlur = hero.querySelector('#hero-blur') || false;

    const updateBlur = () => {
        if (!heroBlur || !heroContent || window.innerWidth < 1024) return;

        setTimeout(() => {
            // Get blur width using hero content width and left offset.
            let blurWidth = heroContent.clientWidth + heroContent.getBoundingClientRect().left;

            // Get left space using hero image left offset.
            const leftSpace = hero.querySelector('.hero-image')?.getBoundingClientRect()?.left || 0;

            if (window.innerWidth > 1919) {
                blurWidth = blurWidth - leftSpace;
            }

            heroBlur.style.setProperty('width', blurWidth + 'px');
            heroBlur.style.setProperty('left', leftSpace + 'px');
        }, 300);
    };

    const updateHeroWithoutBlur = height => {
        if (heroBlur || !heroContent) return;

        heroContent.style.setProperty('padding-top', `${height}px`);
        heroContent.style.setProperty('padding-bottom', `${height}px`);

        const heroMargin =
            document.documentElement.clientHeight >= hero.offsetHeight + height / 2 ? `${height / 4}px` : '';
        heroContent.style.setProperty('margin-top', `${height}px`);
        heroContent.style.setProperty('margin-bottom', heroMargin);
    };

    const updateHeroWithBlur = height => {
        if (!heroBlur) return;

        const heroHeight = `${document.documentElement.clientHeight}px`;
        hero.style.setProperty('height', heroHeight);

        if (!heroContent) return;

        heroContent.style.setProperty(`padding-top`, window.innerWidth > 1023 ? `${height}px` : '2rem');
        heroContent.style.setProperty('padding-bottom', window.innerWidth > 1023 ? '4rem' : '2rem');
    };

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            if (entry.target === header) {
                hero.style.setProperty('margin-top', `${-1 * header.offsetHeight}px`);
            }
        }
    });

    if (header) resizeObserver.observe(header);

    window.addEventListener('resize', () => {
        const height = header.offsetHeight;
        updateHeroWithoutBlur(height);
        updateBlur();
        updateHeroWithBlur(height);
    });

    const height = header.offsetHeight;
    updateHeroWithoutBlur(height);
    updateBlur();
    updateHeroWithBlur(height);

    // Having the main section invisible until the final layout if computed prevents a massive content shift
    document.getElementById('main').style.visibility = 'visible';
};
